/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Vyvážení (mm)`
};

const da_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Balance (mm)`
};

const de_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Bilanz (mm)`
};

const en_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Balance (mm)`
};

const es_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Saldo (mm)`
};

const fr_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Equilibre (mm)`
};

const hu_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Egyenleg (mm)`
};

const it_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Equilibrio (mm)`
};

const nl_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Balans (mm)`
};

const pl_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Równowaga (mm)`
};

const pt_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Equilíbrio (mm)`
};

const sv_attributes_balance = /** @type {(inputs: {}) => string} */ () => {
	return `Balans (mm)`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_balance = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_balance(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_balance", locale)
	if (locale === "cs") return cs_attributes_balance(inputs)
	if (locale === "da") return da_attributes_balance(inputs)
	if (locale === "de") return de_attributes_balance(inputs)
	if (locale === "en") return en_attributes_balance(inputs)
	if (locale === "es") return es_attributes_balance(inputs)
	if (locale === "fr") return fr_attributes_balance(inputs)
	if (locale === "hu") return hu_attributes_balance(inputs)
	if (locale === "it") return it_attributes_balance(inputs)
	if (locale === "nl") return nl_attributes_balance(inputs)
	if (locale === "pl") return pl_attributes_balance(inputs)
	if (locale === "pt") return pt_attributes_balance(inputs)
	return sv_attributes_balance(inputs)
};
export { attributes_balance as "attributes.balance" }